import {EmployeeSchedule} from "../../../model/schedule.model";
import {CustomWeeklyModel} from "../../schedulePerEmployee/common/CustomWeeklyModel";

export class ErrorFromWorkshift {
  id: number;
  referringWorkShift: CustomWeeklyModel;
  weeklyWorkShift: CustomWeeklyModel;
  schedules: EmployeeSchedule[];

  constructor () {
    this.id = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
  }

}
